var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar',{class:_vm.classNames,attrs:{"username":_vm.fullName,"size":_vm.size,"src":_vm.profilePicUrl,"color":"#fff"}})}
var staticRenderFns = []

export { render, staticRenderFns }